module.exports = __webpack_public_path__ + "img/file-unknown.2081cd56.svg";